import { COLORS as COLORS_OLD } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

const breakPoint = {
    DESKTOP: '1600px',
    LAPTOP: '1187px',
    TABLET: '980px',
    MOBILE: '640px',
};

export const About = styled.div`
   flex-direction: column;
   width: 100%;
`;

export const Section = styled.section`
    width: 100%;
    background-color: ${p => p.bgColor || 'transparent'};
`;

export const Grid = styled(GridContainer)`
    padding: 80px 0 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    max-width: 985px;
    min-width: 280px;
    align-items: flex-start;

    @media (max-width: ${breakPoint.MOBILE}) {
        padding: 40px 20px 40px;
    }

    @media (max-width: ${breakPoint.LAPTOP}) {
        padding: 80px 7% 80px;
    }
`;

export const LastGrid = styled(Grid)`
    padding: 80px 7% 0;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContentRow = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: start;

    @media (max-width: ${breakPoint.MOBILE}) {
        width: 100%;
        min-width: 0;
    }
`;

export const TopSection = styled.section`
    width: 100%;
    background: url('/static/images/about/head_backfon-min.jpg');
    background-repeat: no-repeat;
    vertical-align: top;
    object-fit: contain;
    transition: opacity .5s ease-out;
    min-height: 80vh;

    @media (min-width: ${breakPoint.LAPTOP}) {
        background-size: 100%;
    }
`;

export const TopContent = styled.div`
    margin: 0 auto;
    max-width: 985px;
    height: 100%;
    justify-content: center;
    align-items: center;

    @media (max-width: ${breakPoint.MOBILE}) {
        width: 100%;
        min-width: 0;
    }
`;

export const Frame = styled.div`
    padding: 50px;
    background: rgba(255,255,255,.9);
    text-align: center;
    vertical-align: baseline;

    @media (max-width: ${breakPoint.MOBILE}) {
        position: relative;
        bottom: auto;
        margin-top: 250px;
        padding: 40px 20px;
    }
`;

export const Text = styled.p`
    ${FONTS.XXL};
`;

export const TextMB20 = styled(Text)`
    margin-bottom: 20px;
`;

export const MainTitle = styled.h1`
    margin: 0 auto 5px;
    ${FONTS.H1};

    @media (max-width: ${breakPoint.MOBILE}) {
        margin-bottom: 20px;
        ${FONTS.H2};
    }
`;

export const SectionHeading = styled.h2`
    ${FONTS.H1};
    margin-bottom: 40px;
    width: 100%;

    @media (max-width: ${breakPoint.MOBILE}) {
        margin-bottom: 20px;
        ${FONTS.H2};
    }
`;

export const BlockTitle = styled.h3`
    margin-bottom: 0;
    ${FONTS.H2};
    vertical-align:baseline;

    @media (max-width: ${breakPoint.MOBILE}) {
        margin-bottom: 10px;
        ${FONTS.H4};
    }
`;

export const SubTitle = styled.h4`
    ${FONTS.H4};
    text-align: center;
    margin: 0 auto 40px;
`;

export const MainText = styled(Text)`
    ${FONTS.L};
    margin: 20px auto;
`;

export const GreenText = styled(Text)`
    color: #00993b;
    ${FONTS.H1};
    text-align: center;
    margin-bottom: 20px;
    vertical-align: baseline;

    @media (max-width: ${breakPoint.LAPTOP}){
        ${FONTS.H1};
    }
`;

export const Paragraph = styled.p`
    margin-bottom: 20px;
    ${FONTS.XXL};

    @media (max-width: ${breakPoint.LAPTOP}) {
        ${FONTS.L};
    }
`;

export const ImageAdv = styled.img`
    width: 191px;
    height: 562px;
`;

export const Image = styled.img`
    width: 100%;
    object-fit: contain;
`;

export const ImageTeam = styled(Image)`
  margin-top: 30px;
  margin-bottom: -55px;

  @media (max-width: ${breakPoint.MOBILE}) {
    margin-top: 0;
  }
`;

export const Gif = styled.img`
    width: 690px;
    object-fit: contain;
    margin: 0 auto;

    @media (max-width: ${breakPoint.TABLET}) {
        width: 100%;;
    }
`;

export const BlockWithIcon = styled.div`
    margin-bottom: 30px;
    flex-direction: row;
    flex-wrap: nowrap;
`;

export const Icon = styled.div`
    display: inline-block;
    font-family: icomoon;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    text-decoration: none;
    width: 50px;
    font-size: 50px;
    color: ${COLORS.TextPrimary};
    float: left;

    @media (max-width: ${breakPoint.LAPTOP}) {
    width: 30px;
    height: 30px;
    font-size: 30px;
}
`;

export const TextContent = styled.div`
    max-width: 700px;
    padding-left: 20px;
    padding-top: 15px;
    line-height: 25px;
    flex-direction: column;
    align-items: flex-start;
    float: right;

    @media (max-width: ${breakPoint.MOBILE}) {
        padding-top: 5px;
    }

    @media (max-width: ${breakPoint.LAPTOP}) {
        padding-left: 15px;
        padding-top: 3px;
    }
`;

export const TextContentAdv = styled(TextContent)`
    max-width: 600px;
`;

export const AdvWrapper = styled.div`
    width: auto;
`;

export const ImageWrapper = styled.div`

    @media (max-width: ${breakPoint.MOBILE}) {
        display: none;
    }
`;

export const Link = styled.a`
    ${FONTS.MediumS};
    padding-bottom: 1px;
    border-bottom: 1px solid #1e81d6;
    cursor: pointer;
    margin-bottom: 10px;
    color: ${COLORS_OLD.blue};
    transition: all 0.2s linear;

    &:hover {
        color: ${COLORS_OLD.red};
        border-color: ${COLORS_OLD.red};
    }
`;

export const StoryBlock = styled.div`
    margin-bottom: 40px;
    flex-direction: column;
`;

export const StatBlock = styled.div`
    text-align: center;
    flex-direction: column;
`;

export const StatBlockWrapper = styled.div`
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    flex-wrap: nowrap;

    @media (max-width: ${breakPoint.MOBILE}) {
        flex-direction: column;
    }
`;

export const Button = styled(BaseButton)`
    cursor: pointer;
    text-align: center;
    margin-bottom: 3px;
`;
